import { render, staticRenderFns } from "./PeerReviewedPublicationPage.vue?vue&type=template&id=73213c1c&scoped=true"
import script from "./PeerReviewedPublicationPage.vue?vue&type=script&lang=js"
export * from "./PeerReviewedPublicationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73213c1c",
  null
  
)

export default component.exports